import type { FC } from 'react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { Grid } from '@alfa-bank/site-grid-universal';

import type { TErrorDeliveryNotPreparedDesktop } from '../model';
import { routeSwitch, selectAppMeta } from '../../../store';
import { replaceLabelToPhone } from '../../../helpers/helpers';
import { analyticsErrorDeliveryNotPreparedStepSmev } from '../analytics';
import { sendEventSmev } from '../../../helpers/proxy-send-event';

// TODO сделать для каждой ошибки свой screen но с общей view чтобы было проще читать код и прокидывать пресеты с текстами
export const ErrorDesktop: FC<TErrorDeliveryNotPreparedDesktop> = ({
    Aligner,
    Text,
    buttonText,
    nextRoute,
    subtitle,
    title,
}) => {
    const dispatch = useDispatch();
    const { phone } = useSelector(selectAppMeta);
    const subtitleWithPhone = replaceLabelToPhone(subtitle, phone);

    const handleClick = () => {
        if (nextRoute) {
            sendEventSmev(analyticsErrorDeliveryNotPreparedStepSmev.buttonClick);
            dispatch(routeSwitch(nextRoute));
        }
    };

    return (
        <Aligner>
            {title && (
                <Text styler={{ marginBottom: 24, marginTop: 0 }} tag="h2" view="medium">
                    {title}
                </Text>
            )}
            {subtitle && (
                <Text styler={{ marginTop: 0, marginBottom: 0 }} view="primary-medium">
                    {subtitleWithPhone}
                </Text>
            )}
            {buttonText && nextRoute && (
                <Grid collapse columnsWidth={[254]} styler={{ marginTop: 24 }}>
                    <Button block onClick={handleClick} size="s" view="primary">
                        {buttonText}
                    </Button>
                </Grid>
            )}
        </Aligner>
    );
};
